import { render, staticRenderFns } from "./DialogConfirmation.vue?vue&type=template&id=4b7b16db&scoped=true"
import script from "./DialogConfirmation.vue?vue&type=script&lang=js"
export * from "./DialogConfirmation.vue?vue&type=script&lang=js"
import style0 from "./DialogConfirmation.vue?vue&type=style&index=0&id=4b7b16db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7b16db",
  null
  
)

export default component.exports